import { render } from "./seating.vue?vue&type=template&id=7d730ab7&scoped=true"
import script from "./seating.vue?vue&type=script&lang=js"
export * from "./seating.vue?vue&type=script&lang=js"

import "./seating.vue?vue&type=style&index=0&id=7d730ab7&scoped=true&lang=css"
import "./seating.vue?vue&type=style&index=1&id=7d730ab7&lang=css"
script.render = render
script.__scopeId = "data-v-7d730ab7"

export default script